export default __webpack_public_path__ + "static/media/compliance.efdbbaaa.png";